import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from '../TableActionCell.st.css';

var HoverSlot = function HoverSlot(_ref) {
  var display = _ref.display,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["display", "children"]);

  return /*#__PURE__*/React.createElement("span", _extends({
    className: classNames(style.hoverSlot, style[display])
  }, props), children);
};

HoverSlot.propTypes = {
  display: PropTypes.oneOf(['always', 'onHover', 'notOnHover']),
  children: PropTypes.node
};
export default HoverSlot;